import { useState } from "react";

const AddButtonBetweenList = ({
  toggle_push_in_the_middle,
  field_element,
  idx,
}) => {
  const [is_hover, set_is_hover] = useState(false);

  const handleHover = (value) => {
    set_is_hover(value);
  };

  const addButton = (
    <main
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: "10px",
      }}
    >
      <section
        role="button"
        tabIndex={0}
        onClick={() => {
          toggle_push_in_the_middle(field_element.uuid, idx);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggle_push_in_the_middle(field_element.uuid, idx);
          }
        }}
        onMouseLeave={() => handleHover(false)}
        className="button_small background_black"
        style={{
          fontSize: "20px",
        }}
      >
        +
      </section>
    </main>
  );

  const neutral = (
    <main
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "10px",
        marginBottom: "10px",
      }}
    >
      <section
        onMouseEnter={() => handleHover(true)}
        onFocus={() => handleHover(true)}
        tabIndex={0}
      >
        ...
      </section>
    </main>
  );

  return <>{is_hover ? addButton : neutral}</>;
};

export default AddButtonBetweenList;
